import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { formatNumberLocale } from "utils/report.helpers";

import { S } from "./benchmarks.styles";

type Props = {
    value: number;
    numberOfBuildings: number;
    title: string;
    segment: string;
};

export const Benchmark = (props: Props) => {
    const { title, value, numberOfBuildings, segment } = props;
    const { t } = useTranslation();

    const buildingsSample =
        `Benchmark for ${formatNumberLocale(numberOfBuildings, t, {
            max: 0,
        })} ` + t("common.buildings", "buildings").toLowerCase();

    return (
        <S.Benchmark>
            <Stack spacing={2}>
                <S.Header>
                    <Stack height={62}>
                        <S.Title>{title}</S.Title>
                        <S.Segment>{segment}</S.Segment>
                    </Stack>
                    <CloudOutlinedIcon sx={{ color: "text.secondary" }} />
                </S.Header>

                <Box>
                    <S.ValueLabel>
                        {t("assetCoverage.emission", "emission")}:
                    </S.ValueLabel>
                    <S.Value>{value.toFixed(2)}</S.Value>
                    <S.Unit>{t("common.units.kgCO2em2", "kg CO2e/m²")}</S.Unit>
                </Box>

                <S.ValueLabel>{buildingsSample}</S.ValueLabel>
            </Stack>
        </S.Benchmark>
    );
};
